import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-section-skeleton',
  templateUrl: './section-skeleton.component.html',
  styleUrls: ['./section-skeleton.component.scss']
})
export class SectionSkeletonComponent implements OnInit {


  shimmer_list: number[] = [1,2,3];
  @Input('section_type') section_type = 'normal';

  constructor() { }

  ngOnInit(): void {
  }

}
